import Box from '@mui/material/Box';
import type { EImageVariant } from '@onesource/schemas';
import type { ProcessServerConfigFunction } from 'filepond';

import { FileUploader, type EMimeType } from '../file-uploader/file-uploader';

type TMediaUploaderPanelProps = {
  allowedFormats: EMimeType[];
  onUploaded: (key: string) => void;
  /**
   * Factory that builds a process handler for the given enabled variants.
   * Use this (instead of `processHandler`) to enable the image variant checkboxes.
   */
  processHandlerFactory?: (enabledVariants: EImageVariant[]) => ProcessServerConfigFunction;
  /** Direct process handler — use when variant selection is not needed. */
  processHandler?: ProcessServerConfigFunction;
  /** Initial set of enabled variants. Defaults to all variants. */
  imageVariants?: EImageVariant[];
  /** Whether variant checkboxes are interactive (admin) or read-only (user). Defaults to false. */
  variantsEditable?: boolean;
  /** Aspect ratio for the crop tool (width / height). e.g. 1 for square. Defaults to free-form. */
  cropAspectRatio?: number;
  /** Number of file thumbnails to show per row. Defaults to 1. */
  uploaderColumns?: number;
};

export function MediaUploaderPanel({
  allowedFormats,
  processHandlerFactory,
  processHandler,
  onUploaded,
  imageVariants,
  variantsEditable,
  cropAspectRatio,
  uploaderColumns,
}: TMediaUploaderPanelProps) {
  return (
    <Box sx={{ p: 2.5, overflowY: 'auto', flexShrink: 0 }}>
      <FileUploader
        allowedFormats={allowedFormats}
        maxFiles={1}
        processHandlerFactory={processHandlerFactory}
        processHandler={processHandler}
        onUploaded={onUploaded}
        dropzoneHeight="228px"
        imageVariants={imageVariants}
        variantsEditable={variantsEditable}
        cropAspectRatio={cropAspectRatio}
        uploaderColumns={uploaderColumns}
      />
    </Box>
  );
}
